// DesktopFrame — macOS-style window chrome for projectType='desktop'.
// Traffic-light header (red/yellow/green), 16:10 aspect, gray accent.

export const DesktopFrame = {
  flow: 'column',
  width: '100%',
  height: '100%',
  round: 'inherit',
  overflow: 'hidden',
  position: 'relative',

  // macOS-style title bar
  TitleBar: {
    flexShrink: '0',
    flow: 'x',
    align: 'center',
    padding: 'V A',
    height: 'B',
    background: 'gray2.9',
    borderBottom: '1px solid',
    borderColor: 'white.06',
    gap: 'V',

    // Traffic-light buttons
    Controls: {
      flow: 'x',
      gap: 'W',
      align: 'center',
      BtnClose: {
        width: 'Y',
        height: 'Y',
        round: '50%',
        background: 'red.85',
        flexShrink: '0'
      },
      BtnMin: {
        width: 'Y',
        height: 'Y',
        round: '50%',
        background: 'yellow.85',
        flexShrink: '0'
      },
      BtnMax: {
        width: 'Y',
        height: 'Y',
        round: '50%',
        background: 'green.85',
        flexShrink: '0'
      }
    },

    // Window title (centered)
    WinTitle: {
      flexGrow: '1',
      textAlign: 'center',
      fontSize: 'Z1',
      color: 'white.28',
      text: (el, s) => s.name || 'Desktop App',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      paddingRight: 'A'
    }
  },

  // Content area — thumbnail insets here
  ContentArea: {
    flexGrow: '1',
    position: 'relative',
    overflow: 'hidden',
    background: 'black.2',

    EmptyState: {
      if: (el, s) => !s.screenshot && !s.screenshotDev && !s.icon,
      position: 'absolute',
      inset: '0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'Y',
      pointerEvents: 'none',

      Glyph: {
        fontSize: 'B',
        color: 'gray12.2',
        text: '⬜'
      },
      Hint: {
        tag: 'span',
        text: 'Desktop app',
        fontSize: 'Z1',
        color: 'white.22',
        fontStyle: 'italic'
      }
    }
  },

  // Gray accent border
  AccentBorder: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: 'V',
    height: '100%',
    background: 'gray9',
    opacity: '0.8',
    pointerEvents: 'none'
  }
}
